<template>
  <div class="contactMedia">
    <div class="middle">
      <div class="fz24 bl">壹心保代公众号</div>
      <div>
        <img src="../assets/images/QRcode.jpeg" alt="">
      </div>
      <div class="c999">
        扫码关注了解更多
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'contactMedia',
    components: {},
    data() {
      return {
        
      }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .contactMedia {
    width: 788px;
    box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
    padding: 40px 24px;
    &>div {
      margin-top: 30px;
      position: relative;

      .ideaText {
        width: 100%;
        color: #ffffff;
        position: absolute;
        top: 110px;
        text-align: center;

        &>div:first-child {
          font-weight: 600;
        }
      }

      img {
        width: 100%;
      }
    }

    .middle {
      text-align: center;

      img {
        width: 236px;
      }
      .line{
        width: 50px;
        height: 4px;
        background: #FE7B28;
        margin: 20px auto;
      }
    }
  }
</style>